import MuiIconButton from '@material-ui/core/IconButton';
import { withDefaultPropsAndStyles } from '../utils';
export const IconButton = withDefaultPropsAndStyles('IconButton', MuiIconButton, {
    defaultProps: {
        color: 'primary',
    },
});
//# sourceMappingURL=IconButton.js.map